import { getCards } from '@vlabs/api/artemy/client';

export const PAGE_SIZE = 1000;

export async function fetchFirstPageCardIds(listId: string): Promise<string[]> {
  const response = await getCards({
    page: 1,
    page_size: PAGE_SIZE,
    list_ids: [listId],
    targets: ['card_id'],
  });

  return response.cards?.reduce<string[]>((acc, card) => {
    if (card.card_id) acc.push(card.card_id);
    return acc;
  }, []) ?? [];
}
